<script setup>
import AlertNotification from '../../AlertNotification.vue'

defineProps({
  count: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['clear'])
</script>

<template>
  <AlertNotification v-if="count > 0" typeAlert="success-soft" :showAlert="true" :showCloseButton="false" contentAlign="center" class="mb-3">
    <div class="d-flex justify-content-center align-items-center gap-2 text-16">
      <strong>{{ count }} reminder{{ count !== 1 ? 's are' : ' is' }} currently selected.</strong>
      <button type="button" class="btn btn-link text-primary p-0 text-decoration-none" @click="emit('clear')">
        <strong>Clear selections</strong>
      </button>
    </div>
  </AlertNotification>
</template>
